import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  background-color: #C41E3A;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: #A01930;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Message = styled.div`
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 4px;
  
  &.success {
    background-color: #d1e7dd;
    color: #0f5132;
  }
  
  &.error {
    background-color: rgba(196, 30, 58, 0.1);
    color: #C41E3A;
  }
`;

const LabelPreview = styled.div`
  margin-top: 1.5rem;
  text-align: center;
  
  img {
    max-width: 100%;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
`;

const TestShippingLabel = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [label, setLabel] = useState(null);
  
  const handleCreateTestLabel = async () => {
    setLoading(true);
    setResult(null);
    setLabel(null);
    
    try {
      // Use the full Netlify URL
      const netlifyUrl = 'https://benevolent-sfogliatella-83141e.netlify.app/.netlify/functions/test-shipping-label';
      console.log("Creating test label using URL:", netlifyUrl);
      
      const response = await fetch(netlifyUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      console.log("Response status:", response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Error response:", errorText);
        throw new Error(`Error creating test shipping label: ${response.status} ${errorText}`);
      }
      
      // Try to parse the response as JSON
      const responseText = await response.text();
      console.log("Raw response (first 500 chars):", responseText.substring(0, 500));
      
      const result = JSON.parse(responseText);
      console.log("Test label result:", result);
      
      if (result.success) {
        setResult({
          type: 'success',
          message: 'Test shipping label created successfully!'
        });
        
        if (result.label && result.label.label_url) {
          setLabel(result.label);
        }
      } else {
        setResult({
          type: 'error',
          message: result.message || 'Failed to create test shipping label'
        });
      }
    } catch (error) {
      console.error('Error creating test shipping label:', error);
      setResult({
        type: 'error',
        message: error.message || 'Failed to create test shipping label'
      });
    } finally {
      setLoading(false);
    }
  };
  
  const handlePrintLabel = () => {
    if (label && label.label_url) {
      window.open(label.label_url, '_blank');
    }
  };
  
  return (
    <Container>
      <h1>Test Shipping Label</h1>
      <p>This page creates a test shipping label using hardcoded values that should work with Shippo.</p>
      
      <Button onClick={handleCreateTestLabel} disabled={loading}>
        {loading ? 'Creating Test Label...' : 'Create Test Label'}
      </Button>
      
      {result && (
        <Message className={result.type}>
          {result.message}
        </Message>
      )}
      
      {label && label.label_url && (
        <>
          <h2>Label Created Successfully</h2>
          
          <div style={{ marginBottom: '1rem' }}>
            <strong>Tracking Number:</strong> {label.tracking_number}
          </div>
          
          <div style={{ marginBottom: '1rem' }}>
            <strong>Carrier:</strong> {label.provider}
          </div>
          
          <Button onClick={handlePrintLabel} style={{ marginBottom: '1rem' }}>
            Print Label
          </Button>
          
          <LabelPreview>
            <img src={label.label_url} alt="Shipping Label" />
          </LabelPreview>
        </>
      )}
    </Container>
  );
};

export default TestShippingLabel;
